export default {
  confirm: 'Confirmar',
  title: 'Ofertas aplicables',
};
